import {AbstractVisualFeature, allVisuals} from '../visual-feature.js';

class AccountFeature extends AbstractVisualFeature {
    get name() {
        return 'Account';
    }
}

export const Account = new AccountFeature(allVisuals);
